<div *ngIf="merchant" id="shop-info">
  <div id="shop-name">{{ merchant.name }}</div>
  <div id="shop-address">{{ merchant.address }}</div>
  <div *ngIf="merchant.phoneNumber" id="shop-phone">
    {{ merchant.phoneNumber }}
  </div>
</div>
